import router from '../../router'

export default {
    /**
     * Pushes a new page
     *
     * @param _
     * @param route
     * @constructor
     */
    RouterPush(_,route){
        // -- Dont push path if route is the same as current path
        if( router.currentRoute.path === route ) return
        router.push(route)
    },
}